<mat-card class="bot-status-modal">
  <mat-card-title>Bot Status Details</mat-card-title>
  <mat-divider></mat-divider>

  <div class="bot-status-content">
    <!-- Display general BotStatus details -->
    <mat-list>
      <mat-list-item class="status-row">
        <strong>Status:</strong>
        <span>{{ botStatus?.status }}</span>
      </mat-list-item>
      <mat-list-item class="status-row status-row-message">
        <strong>Message:</strong>
        <span matListItemLine>{{ botStatus?.message }}</span>
      </mat-list-item>
    </mat-list>

    <!-- Display Attempts array -->
    <h3>Attempts</h3>
    <mat-divider></mat-divider>
    <mat-accordion>
      <mat-expansion-panel *ngFor="let attempt of botStatus?.attempts">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Attempt - {{ attempt.timestamp | date: "dd/MM/yyyy h:mm a" }}
          </mat-panel-title>
          <mat-panel-description>
            Status: {{ attempt.status }}
          </mat-panel-description>
        </mat-expansion-panel-header>
        <mat-list>
          <mat-list-item class="status-row">
            <strong>Status:</strong>
            <span>{{ attempt.status }}</span>
          </mat-list-item>
          <mat-list-item class="status-row status-row-message">
            <strong>Message:</strong>
            <span matListItemLine>{{ attempt.message }}</span>
          </mat-list-item>
          <mat-list-item class="status-row">
            <strong>Processing Time:</strong>
            <span>{{ attempt.processingTime | timeFormat }}</span>
          </mat-list-item>
          <mat-list-item class="status-row">
            <strong>Timestamp:</strong>
            <span>{{ attempt.timestamp | date: "dd/MM/yyyy h:mm a" }}</span>
          </mat-list-item>
        </mat-list>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div class="modal-actions">
    <button mat-raised-button color="primary" mat-dialog-close>Close</button>
  </div>
</mat-card>